<template lang="pug">
  div(v-if="$store.state.tracks.track_data.length > 0")
    splitpanes.default-theme(@resized="onResized" :style="{'height':`${height}px`, 'background-color':'#CCCCCC'}" )
      pane(:size="28")
        track-side-bar(:height="height-200")
      pane(:size="72")
        live-map(v-if="isLoaded" :style="{'height':`${height-20}px`, 'width':'100%'}" :key="$store.state.tracks.map_key")



</template>
<script>
import LiveMap from "@/modules/maps/components/maps/LiveMap.vue";
import TrackSideBar from "@/modules/maps/components/ui/SideBar/TrackSideBar";
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css'

export default {
  components: {
    LiveMap,
    TrackSideBar,
    Splitpanes,
    Pane
  },

  data: () => ({
    height: null,
    track_key:1,
    isLoaded:false,

  }),

  computed: {},

  methods: {
    onResized:function(){
      this.track_key++;
    },
    onResize:function(){
      this.height = window.innerHeight - 90;
    }
  },

  created() {
    // stretch the elements to fill the height
    this.height = window.innerHeight - 90;
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    this.$store.dispatch("tracks/loadAllTracks").then(() => {
      console.log(this.$store.state.tracks.track_data);
    });
    this.$nextTick(() => {
      this.isLoaded = true;
    });
  }
};
</script>
<style scoped lang="stylus"></style>
